/* ALOURA — couche CRO v15 nettoyée : aucun avis/note n'est fabriqué côté thème. */
(function(){
  'use strict';
  if(window.__alouraFinalCroV15)return;
  window.__alouraFinalCroV15=true;
  function patchCartCopy(){
    var cart=document.querySelector('.alo-cart');
    if(!cart)return;
    var empty=cart.querySelector('.alo-cart__empty');
    if(empty){
      var eyebrow=empty.querySelector('.alo-eyebrow');
      var paragraphs=empty.querySelectorAll('p');
      var cta=empty.querySelector('.alo-button');
      if(eyebrow)eyebrow.textContent='ALOURA · STUDIO LUMIÈRE';
      if(paragraphs.length>1)paragraphs[paragraphs.length-1].textContent='Découvrez nos lampes, appliques, suspensions et lampadaires pour composer la bonne lumière chez vous.';
      if(cta){cta.href='/collections/tous-les-luminaires';cta.innerHTML='Découvrir les luminaires <span aria-hidden="true">→</span>';}
    }
  }
  function normalizeInternalLinks(){
    document.querySelectorAll('a[href="/collections/all"],a[href^="/collections/all?"]').forEach(function(link){
      var query=link.getAttribute('href').split('?')[1];
      link.setAttribute('href','/collections/tous-les-luminaires'+(query?'?'+query:''));
    });
  }
  function normalizeSupportEmail(){
    var oldEmail='bonjour@aloura.fr';
    var newEmail='aloura.supp@gmail.com';
    document.querySelectorAll('a[href^="mailto:'+oldEmail+'"]') .forEach(function(link){link.href='mailto:'+newEmail;if((link.textContent||'').trim()===oldEmail)link.textContent=newEmail;});
    if(!document.createTreeWalker)return;
    var walker=document.createTreeWalker(document.body,NodeFilter.SHOW_TEXT,{acceptNode:function(node){var p=node.parentElement;if(!p||/^(SCRIPT|STYLE|NOSCRIPT|TEXTAREA|CODE|PRE)$/i.test(p.tagName))return NodeFilter.FILTER_REJECT;return node.nodeValue&&node.nodeValue.indexOf(oldEmail)!==-1?NodeFilter.FILTER_ACCEPT:NodeFilter.FILTER_REJECT;}});
    var nodes=[];while(walker.nextNode())nodes.push(walker.currentNode);nodes.forEach(function(node){node.nodeValue=node.nodeValue.split(oldEmail).join(newEmail);});
  }
  function run(){patchCartCopy();normalizeInternalLinks();normalizeSupportEmail();}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',run,{once:true});else run();
})();